import { render, staticRenderFns } from "./TableRestrictionContent.vue?vue&type=template&id=a9188452&scoped=true&"
import script from "./TableRestrictionContent.vue?vue&type=script&lang=js&"
export * from "./TableRestrictionContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9188452",
  null
  
)

export default component.exports